// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.medicalDictionary {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 24px;
  width: 80%;
  margin: 0 auto;
}

.selected-session-mobile{
  width: 100%;
}
.selected-session-hidden-mobile{
  display: none;
}


.dictionaryHeader {
  width: 100%;
  height: 10%;
}

.arrow-wrapper{
  display: flex;
  align-items: center;
  gap: 10px;
}

.arrow-btn{
  background: transparent;
  border: none;
  cursor: pointer;
}


.dictionaryHeader h1 {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0;
}


.recordCount {
  font-size: 14px;
  color: #666;
  margin-top: 4px;
  display: block;
}

.inputSection {
  height: 15%;
  width: 100%;
  display: flex;
  gap: 16px;
  align-items: center;
}

.input-container{
  display: flex;
  align-items: center;
}

.input-buttons{
  display: flex;
  align-items: center;
}

.inputGroup {
  flex: 1 1;
}

.inputGroup label {
  display: block;
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
}

.inputGroup input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  color: #333;
  transition: border-color 0.2s;
}

.inputGroup input:focus {
  outline: none;
  border-color: #3b82f6;
}

.inputGroup input::placeholder {
  color: #a0aec0;
}

.addButton {
  padding: 8px 16px;
  background-color: white;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  color: #333;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  height: 38px;
  white-space: nowrap;
}

.addButton:hover {
  background-color: #f8fafc;
  border-color: #cbd5e1;
}

.dictionaryContent {
  height: 70%;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  overflow: hidden;
}

.tableHeader {
  display: flex;
  background-color: #f8fafc;
  padding: 12px 16px;
  font-weight: 500;
  color: #333;
  border-bottom: 1px solid #e2e8f0;
}

.tableBody {
  height: 88%;
  max-height: 88%;
  overflow-y: auto;
}

/* Custom scrollbar styles */
.tableBody::-webkit-scrollbar {
  width: 8px;
}

.tableBody::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.tableBody::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.tableBody::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.tableRow {
  display: flex;
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
  transition: background-color 0.2s;
}

.tableRow:hover {
  background-color: #f8fafc;
}

.idColumn {
  width: 80px;
  color: #666;
}

.termColumn {
  flex: 1 1;
  padding-right: 16px;
}

.actionColumn {
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.actionButton {
  padding: 4px;
  background: none;
  border: none;
  cursor: pointer;
  color: #64748b;
  border-radius: 4px;
  transition: all 0.2s;
}

.actionButton:hover {
  background-color: #f1f5f9;
  color: #334155;
}

/* ... existing styles ... */

.buttonGroup {
  display: flex;
  gap: 8px;
}

.cancelButton {
  padding: 8px 16px;
  background-color: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  color: #64748b;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  height: 38px;
  white-space: nowrap;
}

.cancelButton:hover {
  background-color: #e2e8f0;
}

.menuContainer {
  position: relative;
}

.dropdownMenu {
  position: absolute;
  right: 0;
  top: 100%;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  width: 120px;
  z-index: 10;
}

.menuItem {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  border: none;
  background: none;
  color: #64748b;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.menuItem:hover {
  background-color: #f8fafc;
  color: #334155;
}

.menuItem:first-child {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.menuItem:last-child {
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}

.menuItem:not(:last-child) {
  border-bottom: 1px solid #e2e8f0;
}

/* @media (max-width: 1024px) {
  .medicalDictionary {
    background: white;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    padding: 24px;
    max-width: 75%;
    margin: 0 auto;
  }
 
} */


@media (max-width:600px){
  .medicalDictionary {
    padding: 0px;
    width: 100%;
    max-width: 100%;
  }
  .dictionaryHeader {
    height: 10%;
    padding: 0 10px;
    padding-top: 30px;
    margin-bottom: 0px;
  }
  .inputSection {
    height: 20%;
    padding: 10px;
    flex-direction: column;
    align-items: center;
    gap: 0;
  }
  .input-container{
    display: flex;
    align-items: center;
  }
  
  .input-buttons{
    display: flex;
    align-items: center;
  }
  
  .dictionaryContent {
    height: 65%;
    margin: 0px 10px;
  }
  
}

`, "",{"version":3,"sources":["webpack://./src/pages/medicalDictionary/dictionary.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;;;AAGA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;;AAGA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,4BAA4B;;AAE5B;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iFAAiF;EACjF,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;;;;;;;GAUG;;;AAGH;EACE;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;EACA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,MAAM;EACR;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;AAEF","sourcesContent":[".medicalDictionary {\r\n  background: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n  padding: 24px;\r\n  width: 80%;\r\n  margin: 0 auto;\r\n}\r\n\r\n.selected-session-mobile{\r\n  width: 100%;\r\n}\r\n.selected-session-hidden-mobile{\r\n  display: none;\r\n}\r\n\r\n\r\n.dictionaryHeader {\r\n  width: 100%;\r\n  height: 10%;\r\n}\r\n\r\n.arrow-wrapper{\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.arrow-btn{\r\n  background: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n\r\n.dictionaryHeader h1 {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #333;\r\n  margin: 0;\r\n}\r\n\r\n\r\n.recordCount {\r\n  font-size: 14px;\r\n  color: #666;\r\n  margin-top: 4px;\r\n  display: block;\r\n}\r\n\r\n.inputSection {\r\n  height: 15%;\r\n  width: 100%;\r\n  display: flex;\r\n  gap: 16px;\r\n  align-items: center;\r\n}\r\n\r\n.input-container{\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.input-buttons{\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.inputGroup {\r\n  flex: 1;\r\n}\r\n\r\n.inputGroup label {\r\n  display: block;\r\n  font-size: 14px;\r\n  color: #333;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.inputGroup input {\r\n  width: 100%;\r\n  padding: 8px 12px;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  color: #333;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.inputGroup input:focus {\r\n  outline: none;\r\n  border-color: #3b82f6;\r\n}\r\n\r\n.inputGroup input::placeholder {\r\n  color: #a0aec0;\r\n}\r\n\r\n.addButton {\r\n  padding: 8px 16px;\r\n  background-color: white;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 6px;\r\n  color: #333;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  height: 38px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.addButton:hover {\r\n  background-color: #f8fafc;\r\n  border-color: #cbd5e1;\r\n}\r\n\r\n.dictionaryContent {\r\n  height: 70%;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n}\r\n\r\n.tableHeader {\r\n  display: flex;\r\n  background-color: #f8fafc;\r\n  padding: 12px 16px;\r\n  font-weight: 500;\r\n  color: #333;\r\n  border-bottom: 1px solid #e2e8f0;\r\n}\r\n\r\n.tableBody {\r\n  height: 88%;\r\n  max-height: 88%;\r\n  overflow-y: auto;\r\n}\r\n\r\n/* Custom scrollbar styles */\r\n.tableBody::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.tableBody::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n}\r\n\r\n.tableBody::-webkit-scrollbar-thumb {\r\n  background: #cbd5e1;\r\n  border-radius: 4px;\r\n}\r\n\r\n.tableBody::-webkit-scrollbar-thumb:hover {\r\n  background: #94a3b8;\r\n}\r\n\r\n.tableRow {\r\n  display: flex;\r\n  padding: 12px 16px;\r\n  border-bottom: 1px solid #e2e8f0;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.tableRow:hover {\r\n  background-color: #f8fafc;\r\n}\r\n\r\n.idColumn {\r\n  width: 80px;\r\n  color: #666;\r\n}\r\n\r\n.termColumn {\r\n  flex: 1;\r\n  padding-right: 16px;\r\n}\r\n\r\n.actionColumn {\r\n  width: 40px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.actionButton {\r\n  padding: 4px;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: #64748b;\r\n  border-radius: 4px;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.actionButton:hover {\r\n  background-color: #f1f5f9;\r\n  color: #334155;\r\n}\r\n\r\n/* ... existing styles ... */\r\n\r\n.buttonGroup {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.cancelButton {\r\n  padding: 8px 16px;\r\n  background-color: #f1f5f9;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 6px;\r\n  color: #64748b;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  height: 38px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.cancelButton:hover {\r\n  background-color: #e2e8f0;\r\n}\r\n\r\n.menuContainer {\r\n  position: relative;\r\n}\r\n\r\n.dropdownMenu {\r\n  position: absolute;\r\n  right: 0;\r\n  top: 100%;\r\n  background: white;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 6px;\r\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\r\n  width: 120px;\r\n  z-index: 10;\r\n}\r\n\r\n.menuItem {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  width: 100%;\r\n  padding: 8px 12px;\r\n  border: none;\r\n  background: none;\r\n  color: #64748b;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.menuItem:hover {\r\n  background-color: #f8fafc;\r\n  color: #334155;\r\n}\r\n\r\n.menuItem:first-child {\r\n  border-top-left-radius: 6px;\r\n  border-top-right-radius: 6px;\r\n}\r\n\r\n.menuItem:last-child {\r\n  border-bottom-left-radius: 6px;\r\n  border-bottom-right-radius: 6px;\r\n}\r\n\r\n.menuItem:not(:last-child) {\r\n  border-bottom: 1px solid #e2e8f0;\r\n}\r\n\r\n/* @media (max-width: 1024px) {\r\n  .medicalDictionary {\r\n    background: white;\r\n    border-radius: 8px;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n    padding: 24px;\r\n    max-width: 75%;\r\n    margin: 0 auto;\r\n  }\r\n \r\n} */\r\n\r\n\r\n@media (max-width:600px){\r\n  .medicalDictionary {\r\n    padding: 0px;\r\n    width: 100%;\r\n    max-width: 100%;\r\n  }\r\n  .dictionaryHeader {\r\n    height: 10%;\r\n    padding: 0 10px;\r\n    padding-top: 30px;\r\n    margin-bottom: 0px;\r\n  }\r\n  .inputSection {\r\n    height: 20%;\r\n    padding: 10px;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 0;\r\n  }\r\n  .input-container{\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  \r\n  .input-buttons{\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  \r\n  .dictionaryContent {\r\n    height: 65%;\r\n    margin: 0px 10px;\r\n  }\r\n  \r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
